<template lang='pug'>
//- Side-Effect-Sidebar
div(:class='$style[`cc-side-effect-sidebar`]')
  div(v-if='rwdType === `desktop`' :class='$style[`cc-side-effect-sidebar-profile`]')
    div(:class='$style[`cc-side-effect-sidebar-thumb`]')
      //- div(v-if='loginProfile.verified === `yes`' :class='[$style[`cc-side-effect-sidebar-verify`], $style[`cc-is-verify`]]')
      //-   div(:class='$style[`cc-side-effect-sidebar-verify-icon`]')
      //-     IconConfirm(:size='16' :color='`#fff`')

      //- div(v-else :class='$style[`cc-side-effect-sidebar-verify`]')
      //-   div(:class='$style[`cc-side-effect-sidebar-verify-icon`]')
      //-     IconConfirm(:size='16' :color='`#fff`')

      figure(v-if='loginProfile.thumbSrc === `` && !loginProfile.public' :class='$style[`cc-side-effect-sidebar-board-avatar`]')
        img(
          v-if='loginProfile.gender === `0`'
          :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          width='100%'
          height='100%')
        img(
          v-else
          :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          width='100%'
          height='100%')

      figure(v-else-if='loginProfile.thumbSrc !== `` && !loginProfile.public' :class='$style[`cc-side-effect-sidebar-board-avatar`]')
        img(
          v-if='loginProfile.gender === `0`'
          :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          width='100%'
          height='100%')
        img(
          v-else
          :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          width='100%'
          height='100%')

      figure(v-else-if='loginProfile.thumbSrc === `` && loginProfile.public' :class='$style[`cc-side-effect-sidebar-board-avatar`]')
        img(
          v-if='loginProfile.gender === `0`'
          :src='`${STATIC_URL}images/common/user/normal_male.webp`'
          width='100%'
          height='100%')
        img(
          v-else
          :src='`${STATIC_URL}images/common/user/normal_female.webp`'
          width='100%'
          height='100%')

      figure(v-else-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-side-effect-sidebar-board-avatar`]')
        img(
          :src='avatarSrcLink(loginProfile.thumbSrc)'
          width='100%'
          height='100%')


    div(:class='$style[`cc-side-effect-sidebar-welcome`]')
      span.font-bold 我的ePRO
      div(:class='$style[`cc-side-effect-sidebar-score`]')
        nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
          span.border-gradient(v-if='subscribeVip === `yes`' :class='$style[`cc-side-effect-sidebar-score-nav-vip`]') VIP會員
          span(v-else :class='$style[`cc-side-effect-sidebar-score-nav-free`]') 基本會員
        nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
          IconCcoin(:size='24')
          span.font-medium(v-if='loginProfile.point' :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') {{ loginProfile.point }}
            span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣
          span.font-medium(v-else :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') 0
            span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣

      div(:class='$style[`cc-side-effect-sidebar-myprofile`]')
        router-link.font-medium(
          role='button'
          tabindex='0'
          aria-label='我的病歷資料'
          to='/ecard'
          :class='$style[`cc-side-effect-sidebar-myprofile-btn`]') 我的病歷

  div(:class='$style[`cc-side-effect-sidebar-nav`]')
    router-link.font-medium(
      tabindex='0'
      aria-label='我的紀錄'
      to='/sideeffect/record'
      :active-class='$style[`js-selected`]'
      :class='$style[`cc-side-effect-nav-btn`]'
      @click='switchBulletinFeature')
      IconConsultant(:size='20')
      span 我的紀錄

    router-link.font-medium(
      tabindex='0'
      aria-label='線上諮詢'
      to='/sideeffect/consult'
      :active-class='$style[`js-selected`]'
      :class='$style[`cc-side-effect-nav-btn`]'
      @click='switchBulletinFeature')
      i(v-if='loginProfile.chat_remind' :class='$style[`cc-side-effect-nav-btn-remind`]')
      IconDialog(:size='20')
      span 線上諮詢

    router-link.font-medium(
      tabindex='0'
      aria-label='報告翻譯'
      to='/sideeffect/translator'
      :active-class='$style[`js-selected`]'
      :class='$style[`cc-side-effect-nav-btn`]'
      @click='switchBulletinFeature')
      IconTranslate(:size='20')
      span 報告翻譯
        
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
// import { mixin as clickaway } from 'vue-clickaway';
import IconConsultant from '../../icon/Consultant';
import IconTranslate from '../../icon/Translate';
import IconDialog from '../../icon/Dialog';
import IconFeature from '../../icon/Feature';
import IconConfirm from '../../icon/Confirm';IconCcoin
import IconCcoin from '../../icon/Ccoin';

export default {
  components: {
    IconConsultant,
    IconTranslate,
    IconDialog,
    IconFeature,
    IconConfirm,
    IconCcoin,
  },

  // created() {
  //   if (this.$route.query.r) {
  //     // console.log('this.$route.r', this.$route.query.r);
  //     this.sideNavType = 'recordDetail';
  //   } else if (this.$route.query.f) {
  //     // console.log('this.$route.f', this.$route.query.f);
  //     this.sideNavType = this.$route.query.f;
  //   } else {
  //     if (this.rwdType === 'desktop') {
  //       this.sideNavType = 'chat';
  //     } else {
  //       this.sideNavType = 'main';
  //     }
  //   }
  // },

  data() {
    return {
      sideNavType: '',
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    switchBulletinFeature(navType) {
      console.log('switchBulletinFeature', navType);
      // this.sideNavType = navType;

      // if (this.rwdType !== 'desktop') {
      //   window.scrollTo(0, 0);
      // }

      // if (this.$route.name === 'effect-record' && this.$route.query.r) {
      //   this.$router.push({
      //     name: 'effect-record'
      //   }).catch(() => true);
      // }

      // console.log('this.$route.name', this.$route.name);
      // this.$router.push({
      //   name: this.$route.name,
      //   query: {
      //     f: navType === 'main' ? '' : navType
      //   },
      // }).catch(() => {})
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      subscribeVip: 'user/exportUserSubscribeVip',
      // authJwtToken: 'user/exportUserJwtToken',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  // watch: {
  //   $route(to, from) {    
  //     console.log('route', this.$route);
  //     if (to.name === 'effect-record' && this.$route.query.r) {
  //       this.sideNavType = 'recordDetail';
  //       this.boardTick += 1;
  //     } else if (to.name === 'effect-record' && this.rwdType !== 'desktop') {
  //       console.log('effect-record', from, this.sideNavType);

  //       if (from.query.r && this.sideNavType === 'recordDetail') {
  //         this.sideNavType = 'main';
  //       } else if (to.query.f) {
  //         this.sideNavType = to.query.f;
  //       }

  //       // if (to.query.f) {
  //       //   this.sideNavType = to.query.f;
  //       // } else {
  //       //   this.sideNavType = 'main';
  //       // }

  //     } else if (to.name === 'effect-record' && this.rwdType === 'desktop') {
  //       if (this.sideNavType === 'main' || this.sideNavType === 'recordDetail') {
  //         this.sideNavType = 'chat';
  //       }
  //     } else {
  //       // if (to.query.f) {
  //       //   this.sideNavType = to.query.f;
  //       // } else {
  //       //   this.sideNavType = 'main';
  //       // }
  //     }
  //   },
  // },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectSidebar.scss';
</style>
